import React, {useContext} from 'react';
import RenderInputType from "./RenderInputType";
import {InsuranceContext} from "../InsuranceContext";
import {initialFormObject} from "../formObject";

function Index(props) {

  const {row, value, onBlur, className, objectKey, functionAfterSelect, variables} = props

  row.value = value
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData


  const changeValueHandler = (value: string) => {

    const name = row.name
    const sendData = {...myData.sendData}
    // اگه سازمانی بود و اگه مقدار
    //showContractRLookUp
    // ترو بود ینی آنچنچ کرده و باید حتما مقادیر مربوطه رو خالی کنم
    if (sendData[objectKey]['contractType'] === "سازمانی" && sendData[objectKey]['showContractRLookUp'] === true) {
      sendData[objectKey]['showContractRLookUp'] = false;
      sendData[objectKey]['showContractRLookUp'] = "";
      sendData[objectKey]['depContractRLookup'] = "";
    }


    sendData[objectKey][name] = value;

    console.log("initialFormObject::::: INPUT")
    console.log(initialFormObject)
    setMyData({sendData})
  };


  // console.log("row.name: "+row.name)
  // console.log("objectKey: "+objectKey)
  // console.log("val: "+ val)
  //variables && alert(variables)
  console.log(className)
  return (<div>
    <div>
      <div className={'div__group__input_select ' + className + ' width__200 '}>
        <label htmlFor="">{row?.title} {row?.required ? <span className={'text-danger'}>*</span> : ''}</label>
        <RenderInputType
          //{...props}
          onChange={changeValueHandler}
          row={row}
          functionAfterSelect={functionAfterSelect}
          variables={variables}
          // className={className}
          //row, onChange, onBlur,functionAfterSelect,variables,className
        />
      </div>
      <small className={row?.errorMessage ? 'text-danger' : ''}
             style={{
               position: 'absolute', fontSize: 10,

             }}
      >{row?.errorMessage} </small>
    </div>
  </div>);
}

export default Index;